module.exports = __webpack_public_path__ + "img/right1.e219589.png";